<div>
  <h2>{{ heading() }}</h2>
  <xui-mat-autocomplete
    #autocomplete
    placeholder="Search Doctors"
    [searchObservable]="searchDoctors"
    [addItemCardText]="'Click here to add a new doctor.'"
    [displayResultsCardTemplate]="doctorsTemplate"
    (addNewItem)="addNewDoctor()"
    [alwaysShowAddCard]="true"
    (itemSelected)="doctorSelected($event)">
  </xui-mat-autocomplete>
  <ng-template #doctorsTemplate let-result="result" let-queryText="queryText">
    <div class="col-12">
      <div class="row">
        <div class="col-6"><span class="py-1 px-3 mb-0 fw-bold" [innerHtml]="result.name | textHighlight: queryText"></span></div>
        <div class="col-3"><span class="py-1 px-3 mb-0" [innerHtml]="result.practiceNumber | textHighlight: queryText"></span></div>
        <div class="col-3"><span class="py-1 px-3 mb-0" [innerHtml]="result.tel | textHighlight: queryText"></span></div>
      </div>
    </div>
  </ng-template>
</div>
<div>
  @for (doctor of array().controls; track $index; let i = $index) {
    <xcs-doctor-display-card [controlFormGroup]="doctor" [index]="i" (edit)="edit($event)" (delete)="remove($event)"></xcs-doctor-display-card>
  }
  @if (array().controls.length === 0) {
    <div class="px-3 pb-3 w-100 text-center">
      <span>{{ emptyMessage() }}</span>
    </div>
  }
</div>
